
import { toString as toString_1, Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, option_type, lambda_type, unit_type, class_type, list_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, ProcedureId, ProcedureTemplateId, FormState__startLoading, ToolId, UnassignToolWithoutNotificationDto, RequestedValue$1, FormState_get_empty, ProcedureId_$reflection, RequestedValue$1_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DTO_CreateProcedureDto_$reflection, DTO_CreateProcedureDto, DTO_GetSenderHooksRequest_$reflection, DTO_GetSenderHooksRequest, DTO_SenderHookDto_$reflection } from "../../Shared/Procedure.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { ToolDetailDto_$reflection } from "../../Shared/Tool.js";
import { isEmpty, singleton, append, max, filter, tryPick, sumBy, choose, empty as empty_1, exists, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { add, empty, contains } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { createObj, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_unassignCmd } from "../../Requests/Tool.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { uploadImage } from "../../Requests/Files.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_2, append as append_1, singleton as singleton_1, collect, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import { TextButton } from "../../Components/Button.js";
import { TextArea } from "../../Components/TextArea.js";
import { TextValue } from "../../Components/Text.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { OpenProcedureModal } from "../../Widgets/Procedure/Form/View.js";
import { Dialog } from "../../Components/Dialog.js";
import { Skeleton } from "../../Components/Skeleton.js";

class HookSource extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Sender", "Receiver"];
    }
}

function HookSource_$reflection() {
    return union_type("Tools.UnassignToolDialog.HookSource", [], HookSource, () => [[], []]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UnassignedToolResponse", "OnUnassignTool", "SetComment", "SenderHooksFetched", "ReceiverHooksFetched", "StartHookProcedure", "ContinueHookProcedure", "HookProcedureCreated", "HookProcedureCompleted", "CloseProcedureModal", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.UnassignToolDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", string_type]], [["Item", ClientApiResponse$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))]], [["Item", ClientApiResponse$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))]], [["Item1", DTO_SenderHookDto_$reflection()], ["Item2", HookSource_$reflection()]], [["procedureId", class_type("System.Guid")], ["templateId", class_type("System.Guid")], ["Item3", HookSource_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]]]);
}

class State extends Record {
    constructor(Tool, Comment$, UserId, SuccessCallback, OnClose, FormState, ReceiverName, SenderHooks, ReceiverHooks, ActiveProcedureId, ActiveProcedureTemplateId, ActiveHookSource, CompletedSenderHookTemplateIds, CompletedReceiverHookTemplateIds, SenderImageFiles, ImageUploading) {
        super();
        this.Tool = Tool;
        this.Comment = Comment$;
        this.UserId = UserId;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.FormState = FormState;
        this.ReceiverName = ReceiverName;
        this.SenderHooks = SenderHooks;
        this.ReceiverHooks = ReceiverHooks;
        this.ActiveProcedureId = ActiveProcedureId;
        this.ActiveProcedureTemplateId = ActiveProcedureTemplateId;
        this.ActiveHookSource = ActiveHookSource;
        this.CompletedSenderHookTemplateIds = CompletedSenderHookTemplateIds;
        this.CompletedReceiverHookTemplateIds = CompletedReceiverHookTemplateIds;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

function State_$reflection() {
    return record_type("Tools.UnassignToolDialog.State", [], State, () => [["Tool", ToolDetailDto_$reflection()], ["Comment", string_type], ["UserId", string_type], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()], ["ReceiverName", RequestedValue$1_$reflection(string_type)], ["SenderHooks", RequestedValue$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))], ["ReceiverHooks", RequestedValue$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))], ["ActiveProcedureId", option_type(ProcedureId_$reflection())], ["ActiveProcedureTemplateId", option_type(class_type("System.Guid"))], ["ActiveHookSource", option_type(HookSource_$reflection())], ["CompletedSenderHookTemplateIds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])], ["CompletedReceiverHookTemplateIds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxSenderImages = 5;

function buildHooksRequest(tool) {
    return new DTO_GetSenderHooksRequest(map((c) => parse(c.CategoryId), tool.Categories), tool.Id);
}

function fetchReturnSenderHooksCmd(tool) {
    const request = buildHooksRequest(tool);
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_SenderHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/return-sender", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_GetSenderHooksRequest_$reflection(), undefined, undefined, undefined)(request))], (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(10, [Item_1])));
}

function fetchReturnReceiverHooksCmd(tool) {
    const request = buildHooksRequest(tool);
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_SenderHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/return-receiver", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_GetSenderHooksRequest_$reflection(), undefined, undefined, undefined)(request))], (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(10, [Item_1])));
}

function hasMandatoryUncompletedHooks(hooks, completedIds) {
    if (hooks.tag === 0) {
        return true;
    }
    else {
        return exists((h) => {
            if (h.IsMandatory) {
                return !contains(h.ProcedureTemplateId, completedIds);
            }
            else {
                return false;
            }
        }, hooks.fields[0]);
    }
}

function init(comment, tool, userId, successCallback, onClose) {
    let matchValue;
    return [new State(tool, comment, userId, successCallback, onClose, FormState_get_empty(), (matchValue = tool.AssignedReceiverInformation, (matchValue == null) ? (new RequestedValue$1(0, [])) : (new RequestedValue$1(1, [matchValue.ReceiverName]))), new RequestedValue$1(0, []), new RequestedValue$1(0, []), undefined, undefined, undefined, empty({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), empty({
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), empty_1(), false), Cmd_batch(ofArray([fetchReturnSenderHooksCmd(tool), fetchReturnReceiverHooksCmd(tool)]))];
}

function update(msg, state) {
    let body, file_1;
    switch (msg.tag) {
        case 1: {
            const matchValue = state.Tool.AssignedReceiverInformation;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const assignedReceiver = matchValue;
                const dto = new UnassignToolWithoutNotificationDto(state.Comment, choose((f) => {
                    if (f.tag === 1) {
                        return f.fields[0].ImageUrl;
                    }
                    else {
                        return undefined;
                    }
                }, state.SenderImageFiles));
                const toolId = new ToolId(parse(state.Tool.Id));
                return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, FormState__startLoading(state.FormState), state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_unassignCmd(toolId, dto, (Item_1) => (new Msg(0, [Item_1])), (Item_2) => (new Msg(10, [Item_2])))];
            }
        }
        case 2:
            return [new State(state.Tool, msg.fields[0], state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 3: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, new RequestedValue$1(1, [empty_1()]), state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, new RequestedValue$1(1, [response_1.fields[0]]), state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 4: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, new RequestedValue$1(1, [empty_1()]), state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, new RequestedValue$1(1, [response_2.fields[0]]), state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 5: {
            const hook = msg.fields[0];
            const dto_1 = new DTO_CreateProcedureDto(state.Tool.Id);
            return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, FormState__startLoading(state.FormState), state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, hook.ProcedureTemplateId, msg.fields[1], state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), (body = toString(0, Auto_generateBoxedEncoder_437914C6(DTO_CreateProcedureDto_$reflection(), undefined, undefined, undefined)(dto_1)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_3) => {
                    const pr = response_3.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), [concat("/api/procedure-templates/", toString_1(new ProcedureTemplateId(hook.ProcedureTemplateId)), ..."/procedure"), body], (Item_3) => (new Msg(7, [Item_3])), (Item_4) => (new Msg(10, [Item_4]))))];
        }
        case 6:
            return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, new ProcedureId(msg.fields[0]), msg.fields[1], msg.fields[2], state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 7: {
            const response_4 = msg.fields[0];
            if (response_4.tag === 1) {
                return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, FormState__setValidationResponse_5219762A(state.FormState, response_4.fields[0]), state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.ReceiverName, state.SenderHooks, state.ReceiverHooks, new ProcedureId(parse(response_4.fields[0])), state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 8: {
            const matchValue_1 = state.ActiveHookSource;
            const matchValue_2 = state.ActiveProcedureTemplateId;
            let matchResult, templateId_1, templateId_2;
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 1) {
                    if (matchValue_2 != null) {
                        matchResult = 1;
                        templateId_2 = matchValue_2;
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else if (matchValue_2 != null) {
                    matchResult = 0;
                    templateId_1 = matchValue_2;
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 2;
            }
            switch (matchResult) {
                case 0:
                    return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, undefined, undefined, undefined, add(templateId_1, state.CompletedSenderHookTemplateIds), state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
                case 1:
                    return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, undefined, undefined, undefined, state.CompletedSenderHookTemplateIds, add(templateId_2, state.CompletedReceiverHookTemplateIds), state.SenderImageFiles, state.ImageUploading), Cmd_none()];
                default:
                    return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, undefined, undefined, undefined, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 9:
            return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, undefined, undefined, undefined, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_batch(ofArray([fetchReturnSenderHooksCmd(state.Tool), fetchReturnReceiverHooksCmd(state.Tool)]))];
        case 10:
            return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, false), Cmd_none()];
        case 11: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x_1, y) => ((x_1 + y) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult_1, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult_1 = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, newFiles, true), uploadImage((Item_7) => (new Msg(12, [Item_7])), (Item_8) => (new Msg(10, [Item_8])), formData)];
                }
                default:
                    return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, newFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 12: {
            const response_5 = msg.fields[0];
            switch (response_5.tag) {
                case 0:
                    return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_2, y_1) => (comparePrimitives(x_2, y_1) | 0),
                    })) | 0;
                    return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_5.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false), Cmd_none()];
                }
            }
        }
        default: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Tool, state.Comment, state.UserId, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.ReceiverName, state.SenderHooks, state.ReceiverHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.ActiveHookSource, state.CompletedSenderHookTemplateIds, state.CompletedReceiverHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
    }
}

function HooksSection(props) {
    let elems_4, elems_3;
    const patternInput = useTranslation();
    if (isEmpty(props.Hooks)) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
            children: patternInput[0](props.TitleKey),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_3 = toList(delay(() => collect((hook) => {
            let elems_2;
            const isCompleted = contains(hook.ProcedureTemplateId, props.CompletedTemplateIds);
            return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "gap-2"])], (elems_2 = toList(delay(() => {
                let children;
                return append_1(singleton_1((children = toList(delay(() => {
                    let elems, elems_1;
                    return isCompleted ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-green"])], (elems = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-border"])], (elems_1 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                })), reactElement("div", {
                    children: reactApi.Children.toArray(Array.from(children)),
                }))), delay(() => (isCompleted ? singleton_1(reactElement("span", {
                    className: join(" ", ["text-sm"]),
                    children: hook.ProcedureTemplateName,
                })) : singleton_1(createElement(TextButton, {
                    ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
                    Label: hook.ProcedureTemplateName,
                    OnClick: () => {
                        const matchValue = hook.ProcedureId;
                        if (matchValue == null) {
                            props.Dispatch(new Msg(5, [hook, props.HookSource]));
                        }
                        else {
                            props.Dispatch(new Msg(6, [matchValue, hook.ProcedureTemplateId, props.HookSource]));
                        }
                    },
                    TestId: `${props.TestIdPrefix}-procedure-${hook.ProcedureTemplateId}`,
                    Variant: "blueButton",
                })))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }, props.Hooks))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    }
}

function DialogBody(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-5"])], (elems_2 = toList(delay(() => {
        let arg_1;
        return append_1(singleton_1(reactElement("p", {
            children: (arg_1 = {
                user: props.ReceiverName,
            }, patternInput[1].t("tool.dialog_unassign_tool_query", arg_1)),
        })), delay(() => append_1(singleton_1(createElement(HooksSection, {
            CompletedTemplateIds: props.CompletedSenderHookTemplateIds,
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            HookSource: new HookSource(0, []),
            Hooks: props.SenderHooks,
            TestIdPrefix: "return-sender",
            TitleKey: "procedure.hooks.sender_procedures_return",
        })), delay(() => append_1(singleton_1(createElement(HooksSection, {
            CompletedTemplateIds: props.CompletedReceiverHookTemplateIds,
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            HookSource: new HookSource(1, []),
            Hooks: props.ReceiverHooks,
            TestIdPrefix: "return-receiver",
            TitleKey: "procedure.hooks.receiver_procedures_return",
        })), delay(() => {
            let elems;
            return append_1(singleton_1(reactElement("div", createObj(singleton((elems = [createElement(TextArea, {
                ComponentState: componentState,
                Label: t("general.comment"),
                OnChange: props.SetComment,
                TestId: "unassign-tool-dialog-comment-test-id",
                Value: props.Comment,
            })], ["children", reactApi.Children.toArray(Array.from(elems))]))))), delay(() => {
                let elems_1;
                return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_1 = [createElement(TextValue, {
                    FontWeight: "bold",
                    TestId: "",
                    Text: t("assignment_notification.sender_images"),
                }), createElement(ImageUpload, {
                    ComponentState: props.ImageUploading ? "disabled" : componentState,
                    SelectedFiles: props.SenderImageFiles,
                    SetSelectedFile: (files) => {
                        props.Dispatch(new Msg(11, [files]));
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    const matchValue = FormState__getValidation(props.FormState, t, "global");
                    if (matchValue == null) {
                        return empty_2();
                    }
                    else {
                        return singleton_1(createElement(ErrorAlert, {
                            Label: matchValue,
                        }));
                    }
                }));
            }));
        }))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function UnassignDialog(props) {
    let elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init("", props.Tool, props.UserId, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    if (props.Tool.AssignedReceiverInformation == null) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(singleton((elems = toList(delay(() => {
            let matchValue_1;
            return append_1((matchValue_1 = state_1.ActiveProcedureId, (matchValue_1 == null) ? (empty_2()) : singleton_1(createElement(OpenProcedureModal, {
                IsOpen: true,
                OnCancelCallback: () => {
                    dispatch(new Msg(9, []));
                },
                OnClose: () => {
                    dispatch(new Msg(9, []));
                },
                OnSuccessCallback: () => {
                    dispatch(new Msg(8, []));
                },
                ProcedureId: matchValue_1,
            }))), delay(() => {
                let Title, Label_1;
                return singleton_1(createElement(Dialog, (Title = t("tool.back_to_storage"), {
                    Body: toList(delay(() => {
                        const matchValue_2 = state_1.ReceiverName;
                        const matchValue_3 = state_1.SenderHooks;
                        const matchValue_4 = state_1.ReceiverHooks;
                        let matchResult, receiver, receiverHooks, senderHooks;
                        if (matchValue_2.tag === 1) {
                            if (matchValue_3.tag === 1) {
                                if (matchValue_4.tag === 1) {
                                    matchResult = 0;
                                    receiver = matchValue_2.fields[0];
                                    receiverHooks = matchValue_4.fields[0];
                                    senderHooks = matchValue_3.fields[0];
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                        switch (matchResult) {
                            case 0:
                                return singleton_1(createElement(DialogBody, {
                                    Comment: state_1.Comment,
                                    CompletedReceiverHookTemplateIds: state_1.CompletedReceiverHookTemplateIds,
                                    CompletedSenderHookTemplateIds: state_1.CompletedSenderHookTemplateIds,
                                    Dispatch: dispatch,
                                    FormState: state_1.FormState,
                                    ImageUploading: state_1.ImageUploading,
                                    ReceiverHooks: receiverHooks,
                                    ReceiverName: receiver,
                                    SenderHooks: senderHooks,
                                    SenderImageFiles: state_1.SenderImageFiles,
                                    SetComment: (value) => {
                                        dispatch(new Msg(2, [value]));
                                    },
                                }));
                            default:
                                return singleton_1(createElement(Skeleton, {
                                    Variant: "normal",
                                }));
                        }
                    })),
                    Controls: ofArray([createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("general.cancel"),
                        OnClick: props.OnClose,
                        TestId: "close-reservation-dialog-test-id",
                        Variant: "blueButton",
                    }), createElement(TextButton, (Label_1 = t("general.save"), {
                        ComponentState: (state_1.FormState.IsLoading ? true : state_1.ImageUploading) ? "disabled" : ((hasMandatoryUncompletedHooks(state_1.SenderHooks, state_1.CompletedSenderHookTemplateIds) ? true : hasMandatoryUncompletedHooks(state_1.ReceiverHooks, state_1.CompletedReceiverHookTemplateIds)) ? "disabled" : "enabled"),
                        Label: Label_1,
                        OnClick: () => {
                            dispatch(new Msg(1, []));
                        },
                        TestId: "save-unassign-dialog-test-id",
                        Variant: "blueButton",
                    }))]),
                    IsOpen: props.IsOpen,
                    OnClose: props.OnClose,
                    Title: Title,
                })));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems))]))));
    }
}

